import React from "react";
import { useState, useEffect, useContext } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../HandleHttpErrors";
import { useNavigate, useLocation } from "react-router-dom";
import { Modal, Table } from "react-bootstrap";
import GetParsedDate from "./GetParsedDate";
import AuditContext from "../shared/context/AuditProvider";
const baseURL = process.env.REACT_APP_API_JOBS;

function AuditModal() {
  const { showAudit, setShowAudit, model, srcId } = useContext(AuditContext);
  const [audit, setAudit] = useState(null);
  const axiosPrivate = useAxiosPrivate("application/json");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const getData = async () => {
      try {
        const response = await axiosPrivate.get(
          baseURL + "audit?" + "model=" + model + "&srcid=" + srcId,
          {
            signal: controller.signal,
          }
        );
        isMounted && setAudit(response.data);
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };
    getData();
  }, [showAudit]);

  return (
    <>
      <Modal
        show={showAudit}
        onHide={() => setShowAudit(false)}
        backdrop="static"
        keyboard={false}
        size="xl"
      >
        <Modal.Header className="mx-auto" closeButton>
          <Modal.Title>תיעוד השינויים</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th>זמן ביצוע</th>
                <th>משתמש מבצע</th>
                <th>שדה</th>
                <th>ערך ישן</th>
                <th>ערך חדש</th>
              </tr>
            </thead>
            <tbody>
              {audit
                ?.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))
                .map((rec) => (
                  <tr key={rec.id}>
                    <td>
                      {" "}
                      <GetParsedDate strDate={rec.timestamp} withTime={true} />
                    </td>
                    <td>{rec.user_name}</td>
                    <td>{rec.field_name}</td>

                    <td
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {!isNaN(new Date(rec.old_value)) &&
                      /^[0-9\-\/:. ]+$/.test(rec.old_value) ? (
                        <>
                          <GetParsedDate
                            strDate={rec.old_value}
                            withTime={false}
                          />
                        </>
                      ) : (
                        rec.old_value
                      )}
                    </td>

                    <td>
                      {!isNaN(new Date(rec.new_value)) &&
                      /^[0-9\-\/:. ]+$/.test(rec.new_value) ? (
                        <GetParsedDate
                          strDate={rec.new_value}
                          withTime={true}
                        />
                      ) : (
                        rec.new_value
                      )}
                    </td>
                  </tr>
                ))}
            </tbody>
          </Table>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default AuditModal;
